import request from '@/api/request' // 确保路径正确，指向你的 request.js

export default {
    getDashboardData(data) {
        return request({
            url: '/login/account',
            method: 'post',
            params: data
        })
    },
    logout() {
        return request({
            url: '/logout',
            method: 'post'
        })
    },
    // 新增的方法：提交组织申请
    applyOrganization(data) {
        return request({
            url: '/organization/apply',
            method: 'post',
            data
        })
    }
}